import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import genderSelectionLoaderJson from '@/data/lottie-animations/genderSelectionLoader.json'

// DEV-34990: lymphatic UTM variant of loader-tai-chi-walking.
const schema: LandingScreenSchema = {
	order: [
		'LandingLanguageButton',
		'LandingHead',
		'LandingTitle',
		'LandingLottieAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.tai_chi.lymphatic.loader_title'),
			size: 'small',
			customStyles: {
				marginLeft: '3rem',
				marginRight: '3rem',
			},
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: genderSelectionLoaderJson,
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
